import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { ButtonGroup, Label, Dropdown, DropdownToggle, Input, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withAlert } from 'react-alert';
import $ from 'jquery';

class PrintDocumentModal extends React.Component {
    constructor(props){
        super(props)

        this.state = {
            ...props
        }

        this.printDocument = this.printDocument.bind(this)
        this.handleDropDownChange = this.handleDropDownChange.bind(this)

    }

    componentDidMount() {
        fetch(window.location.protocol + '//' + window.location.host + "/api/printing/destinations")
            .then(res => res.json())
            .then(result => {
                this.setState({
                    destinations: result.destinations
                })                
            })
    }

    componentDidUpdate(prevProps, prevState) {

        if(this.state.destinations != prevState.destinations && this.state.destinations.length > 0)
            this.setState({
                group: this.state.destinations[0].Group
            })
        
    }

    printDocument () {
        fetch(window.location.protocol + '//' + window.location.host + "/api/printing/send_print_request", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body:JSON.stringify({document: this.props.file, group: this.state.group})
            })
            .then(res => res.json())
            .then(result => {
                // if(result.status == 200)
                //     this.props.alert.success(result.message);
                // else 
                //     this.props.alert.error(result.message);

                this.setState({
                    alert_message: result.message,
                    alert_status: result.status
                })
                
                if(result.status == 200) {
                    setTimeout(this.props.toggle(), 2000);
                }
            })
    }

    handleDropDownChange (event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render(){

        let groups = []
        let alert_message = {}

        if(this.state.destinations)
            // #10190: Disable destinations whose print client is not currently connected.
            this.state.destinations.forEach(destination => {
                const connected = destination.IsConnected !== false;
                groups.push(
                    <option
                        key={destination.id}
                        value={destination.Group}
                        disabled={!connected}
                        style={!connected ? { color: '#999' } : {}}
                    >
                        {destination.Group}{!connected ? ' (not connected)' : ''}
                    </option>
                );
            });

        if(this.state.alert_message)
            if(this.state.alert_status == 200)
                alert_message = <Alert color="success">
                                    {this.state.alert_message}
                                </Alert>
            else
                alert_message = <Alert color="danger">
                                    {this.state.alert_message}
                                </Alert>
        else
            alert_message = <div />
        
        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>
                File: {this.props.document}
                <br />
                </ModalHeader>
                <ModalBody>
                    <h1 style={{fontSize:'1rem !important'}}>Print to location</h1>
                    <br />
                    <Label for="group">Name</Label>
                    <Input type="select" name="group" onChange={this.handleDropDownChange}>
                        {groups}
                    </Input>
                    <br />
                    {alert_message}
                </ModalBody>
                <ModalFooter>
                <Button color="primary" onClick={this.printDocument}>Print</Button>
                    <Button color="danger" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default withAlert()(PrintDocumentModal);